// extracted by mini-css-extract-plugin
export default {"root":"QibriLogo_root__UQgO+","co-standard":"QibriLogo_co-standard__EIcQe","co-black":"QibriLogo_co-black__MGiUl","co-negative":"QibriLogo_co-negative__0ZvTk"};